import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: '/shopify/', component: require('../templates/Default.vue').default,
        children: [
            { path: 'product-list', name: 'shopify-product-list', component: require('../pages/shopify/ProductList.vue').default },
            { path: 'collection-list', name: 'shopify-collection-list', component: require('../pages/shopify/CollectionList.vue').default }
        ],
    },

    {
        path: '/rack/', component: require('../templates/Default.vue').default,
        children: [
            { path: ':id/cluster', name: 'cluster-list', component: require('../pages/racks/clusters/list.vue').default },
            { path: 'list', name: 'rack-list', component: require('../pages/racks/list.vue').default },
            { path: 'map', name: 'rack-map', component: require('../pages/racks/maps/list.vue').default },
        ],
    },
    {
        path: '/', component: require('../templates/Default.vue').default,
        children: [
            { path: 'product-list', name: "product-list", component: require('../components/ProductList.vue').default },
            { path: 'product/rating', name: "product-rating", component: require('../pages/product/ProductRating.vue').default },
            { path: 'product/comprehensive-analysis', name: "product-comprehensive-analysis", component: require('../pages/product/ProductComprehensiveAnalysis.vue').default },
            { path: 'product/ebitda-analysis', name: "product-ebitda-analysis", component: require('../pages/product/ProductEBITDAAnalysis.vue').default },
            { path: 'product/resa-analysis', name: "product-resa-analysis", component: require('../pages/product/ProductRESAAnalysis.vue').default },
            { path: 'search/barcodescanner', name: "product-barcodescanner", component: require('../pages/product/BarcodeScanner.vue').default },
            { path: 'testate-ordini', name: "testate-ordini", component: require('../pages/TestateOrdini.vue').default },
            { path: 'product-sell', name: "product-sell", component: require('../pages/product/ProductSell.vue').default },
            { path: 'product', name: "product", component: require('../components/ProductV2.vue').default },
            { path: 'product-v1', name: "product-v1", component: require('../components/Product.vue').default },
            { path: 'product-restock-alert', name: "product-restock-alert", component: require('../pages/product/ProductRestockAlert.vue').default },
            { path: 'product-restock-alert-shop', name: "product-restock-alert-shop", component: require('../pages/product/ProductRestockAlertShop.vue').default },
            { path: 'product-reorder-shop', name: "product-reorder-shop", component: require('../pages/product/ProductRestockShop.vue').default },
            { path: 'planogram', name: "planogram", component: require('../pages/planogram/PlanogramPage.vue').default },
            { path: 'users', name: "users", component: require('../components/Users.vue').default },
            { path: 'create-order', name: "create-order", component: require('../pages/CreateOrder.vue').default },
            { path: 'read-order', name: "read-order", component: require('../pages/ReadOrder.vue').default },
            { path: 'incassi-list', name: "incassi-list", component: require('../pages/incassi/IncassiList.vue').default },
            { path: 'kpi', name: "kpi", component: require('../pages/incassi/Kpi.vue').default },
            { path: 'fatturati', name: "fatturati", component: require('../pages/incassi/Fatturati.vue').default },
            { path: 'montanti', name: "montanti", component: require('../pages/incassi/Montanti.vue').default },
            { path: 'montanti-week', name: "montanti-week", component: require('../pages/incassi/MontantiWeek.vue').default },
            { path: 'shop-list', name: "shop-list", component: require('../pages/shop/ShopList.vue').default },
            { path: 'report-list', name: "report-list", component: require('../pages/reports/ReportList.vue').default },
            { path: 'reorder-reports', name: "reorder-reports", component: require('../pages/reorder/ReorderReportList.vue').default },
            { path: 'reorder-reports/:id', name: "reorder-report-detail", component: require('../pages/reorder/ReorderReportDetail.vue').default },
            { path: ':report/:id?', name: "report1", component: require('../pages/reports/Report1.vue').default },
        ]
    },
    {
        path: '/', component: require('../templates/Blanc.vue').default,
        children: [
            { path: 'login', name: 'login', component: require('../components/Login.vue').default },
            { path: 'recupero-password', name: "recupero-password", component: require('../pages/RecoverPassword.vue').default },
        ],
    },
    { path: '/:pathMatch(.*)*', name: 'NotFound', redirect: '/not-found' },

];
const router = new VueRouter({
    mode: 'history',
    routes
})

export default router;
